import React from "react";
import { Link } from "react-router";
import InputField from "components/InputField/InputField";
import PropTypes from "prop-types";
import moment from "moment";

const labels = {
  name: "Name",
  slug: "Slug",
};

const ClientUrlForm = ({
  // user,
  client_url: { name, slug, webinar_ids },
  isEdit,
  onFieldChange,
  onSubmit,
  goToAddWebinarsPage,
  role,
  webinars,
  errors = {},
}) => {
  return (
    <div className="container_records">
      <div className="add_webinar add_user">
        <h3>{isEdit ? "Edit Client Url" : "Add Client Url"}</h3>
        <div className="add_webinar_bg row">
          <form className="col s12">
            <div className="row">
              {[
                {
                  field_name: "name",
                  value: name,
                },
                {
                  field_name: "slug",
                  value: slug,
                },
              ].map((e) => (
                <InputField
                  className="col s12 m6"
                  label={labels[e.field_name]}
                  onChange={onFieldChange}
                  errors={errors[e.field_name]}
                  {...e}
                />
              ))}
              {role === "admin" && webinars && (
                <div className="col s12">
                  <div style={{ overflowX: "auto" }}>
                    <table>
                      <thead>
                        <tr>
                          <th>Webinar</th>
                          <th>Start</th>
                          <th>End</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {webinars.map((webinar) => (
                          <tr key={`client_url_webinar_${webinar.id}`}>
                            <td>{webinar.webinar_title}</td>
                            <td>
                              {webinar.start_date
                                ? moment(webinar.start_date).format(
                                    "YYYY-MM-DD HH:mm"
                                  )
                                : "-"}
                            </td>
                            <td>
                              {webinar.end_date
                                ? moment(webinar.end_date).format(
                                    "YYYY-MM-DD HH:mm"
                                  )
                                : "-"}
                            </td>
                            <td>
                              <Link
                                href={`/webinars/${webinar.id}`}
                                target="_blank"
                              >
                                Open
                              </Link>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
              {role === "admin" && (
                <div className="col s12">
                  <a
                    className="button_classic-new"
                    onClick={goToAddWebinarsPage}
                  >
                    {isEdit ? "Add/Remove Webinars" : "Add Webinars"}
                  </a>
                </div>
              )}
              <div className="submit_center col s12">
                <button
                  onClick={onSubmit}
                  className="button_classic"
                  type="button"
                  name="button"
                >
                  {isEdit ? "Save" : "Create"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
ClientUrlForm.defaultProps = {};

ClientUrlForm.propTypes = {
  client_url: PropTypes.object,
  onFieldChange: PropTypes.func,
  onSubmit: PropTypes.func,
  errors: PropTypes.array,
};

export default ClientUrlForm;



// WEBPACK FOOTER //
// ./src/components/Admin/ClientUrls/ClientUrlForm.jsx